'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record, List } from 'immutable';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
import TimeRange from 'MeetingsBase/models/TimeRange';
import PublicMeetingsUser from './PublicMeetingsUser';
var defaults = {
  id: null,
  busyTimes: List(),
  offline: false,
  firstName: null,
  lastName: null,
  email: null,
  meetingsUser: null
};

var UserBusyTimes = /*#__PURE__*/function (_Record) {
  _inherits(UserBusyTimes, _Record);

  function UserBusyTimes() {
    _classCallCheck(this, UserBusyTimes);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserBusyTimes).apply(this, arguments));
  }

  _createClass(UserBusyTimes, null, [{
    key: "from",
    value: function from(json) {
      return new UserBusyTimes({
        id: json.meetingsUser.id,
        busyTimes: List(json.busyTimes.map(function (b) {
          return TimeRange.from(b);
        })),
        offline: json.isOffline,
        firstName: getIn(['meetingsUser', 'userProfile', 'firstName'], json),
        lastName: getIn(['meetingsUser', 'userProfile', 'lastName'], json),
        email: getIn(['meetingsUser', 'userProfile', 'email'], json),
        meetingsUser: PublicMeetingsUser.from(get('meetingsUser', json))
      });
    }
  }]);

  return UserBusyTimes;
}(Record(defaults));

export { UserBusyTimes as default };